import React, { useEffect, useRef, useState } from 'react';

export default function EditableTextInput({ value, onCommit, type = 'text', className = '', placeholder, style }) {
  const normalizedValue = value === null || value === undefined ? '' : String(value);
  const [draft, setDraft] = useState(normalizedValue);
  const committedRef = useRef(normalizedValue);
  const focusedRef = useRef(false);

  useEffect(() => {
    if (!focusedRef.current && normalizedValue !== committedRef.current) {
      committedRef.current = normalizedValue;
      setDraft(normalizedValue);
    }
  }, [normalizedValue]);

  const commit = () => {
    focusedRef.current = false;
    if (draft !== committedRef.current) {
      committedRef.current = draft;
      onCommit(draft);
    }
  };

  const cancel = () => {
    focusedRef.current = false;
    setDraft(committedRef.current);
  };

  return (
    <input
      type={type}
      value={draft}
      className={className}
      placeholder={placeholder}
      style={style}
      onFocus={() => { focusedRef.current = true; }}
      onChange={(event) => setDraft(event.target.value)}
      onBlur={commit}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.currentTarget.blur();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          cancel();
          event.currentTarget.blur();
        }
      }}
    />
  );
}
